export enum PageConfig {
  PageLayoutId = 'page-layout',
}
